import React from "react";
import { colorFunctionalGray70, colorMiscGray80, iconSizeS, spacingM, spacingS, spacingXs, spacingXxs, } from "@rhumbix/rmbx_design_system_design_tokens";
import styled from "styled-components";
/**
 * The default component for rendering an action option in the Selector
 *
 * @param   option  The option to render
 * @returns The rendered option for the selector
 */
const ActionOptionComponent = props => {
    const { icon, label } = props.option;
    return (React.createElement(StyledOption, { className: "action-option-content" },
        icon,
        React.createElement(Title, null, label)));
};
export default ActionOptionComponent;
const StyledOption = styled.div `
    color: ${colorFunctionalGray70};
    display: flex;
    flex-direction: row;
    gap: ${spacingXxs};
    line-height: ${spacingM};
    margin-bottom: ${spacingXs};
    padding: ${spacingXs};
    width: 100%;

    svg {
        color: ${colorMiscGray80};
        cursor: inherit !important;
        flex-shrink: 1;
        width: ${iconSizeS};
    }
`;
const Title = styled.div `
    color: ${colorMiscGray80};
    flex: 1;
    font-size: 14px;
    font-weight: 500;
    margin-right: ${spacingS};
`;
